import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Texas.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Shaping the Future of Mobile App Development in Texas</h2>
            <p>
              Businesses worldwide have realized the potential of emerging tech
              in revolutionizing the operational ecosystem. With mobile app
              development in Texas, Tek is accelerating industrial processes,
              elevating brands, entertaining customers and cutting down business
              costs. And when we say emerging tech, we capitalize on the endless
              possibilities for business growth with blockchain, Internet of
              Things and advanced extensions of Artificial Intelligence.
            </p>
            <p>
              Our team of app developers in Texas adheres to top-tier coding
              standards, supported by a devoted team that offers robust
              after-sales support & maintenance. Supported by cloud-based
              hosting and deployment services, our dedication is to boost every
              aspect of your digital journey.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
